import { Navigate, useSearchParams } from 'react-router-dom';
import { readSubscriptionGateState } from '@/lib/subscriptionGate';

const SubscriptionRequiredLegacyRedirect = () => {
  const [searchParams] = useSearchParams();
  const fromQuery = searchParams.get('from')?.trim() || '';
  const gateReturn = readSubscriptionGateState()?.returnTo;
  const returnTo = fromQuery.startsWith('/')
    ? fromQuery
    : (typeof gateReturn === 'string' && gateReturn.startsWith('/') ? gateReturn : '/');

  return <Navigate to={returnTo} replace />;
};

export default SubscriptionRequiredLegacyRedirect;
